// Import the uuid library
import {v4 as uuidv4} from 'uuid';

// Export a function that generates and returns a UUID
export const generateUuid = () => {
  return uuidv4();
};
